// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nzuXgaNlWlaEF1hh2NBO {
  margin-bottom: 44px;
}
@media only screen and (max-width: 1023px) {
  .nzuXgaNlWlaEF1hh2NBO {
    margin-bottom: 32px;
  }
}
@media only screen and (max-width: 767px) {
  .nzuXgaNlWlaEF1hh2NBO {
    flex-wrap: wrap;
    margin-bottom: 24px;
  }
}
.nzuXgaNlWlaEF1hh2NBO .vX9M5hWWqM3YLueggWdM {
  margin-right: auto;
}
@media only screen and (max-width: 1023px) {
  .nzuXgaNlWlaEF1hh2NBO .vX9M5hWWqM3YLueggWdM {
    width: 250px;
  }
}
@media only screen and (max-width: 767px) {
  .nzuXgaNlWlaEF1hh2NBO .vX9M5hWWqM3YLueggWdM {
    width: 100%;
    margin: 0 0 16px;
  }
}
@media only screen and (max-width: 1023px) {
  .nzuXgaNlWlaEF1hh2NBO.Qkwr8d5qz_GSOip5WRo4 {
    display: none;
  }
}

.IRyGOm_CKwD_geczKAF5 {
  margin-right: 24px;
}
@media only screen and (max-width: 767px) {
  .IRyGOm_CKwD_geczKAF5 {
    margin: 0 0 16px;
  }
}

.EfBrtUtmpKTkb4q7_lzQ {
  display: flex;
}
@media only screen and (max-width: 767px) {
  .EfBrtUtmpKTkb4q7_lzQ {
    width: 100%;
  }
}

.uYmPwd3uQ3VUHxGR7NAa {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .uYmPwd3uQ3VUHxGR7NAa {
    flex: 1;
  }
}
.uYmPwd3uQ3VUHxGR7NAa:hover, .uYmPwd3uQ3VUHxGR7NAa.ifWVAp1joHrHt533r0Zc {
  color: #1A1D1F;
}
.dark-mode .uYmPwd3uQ3VUHxGR7NAa:hover, .dark-mode .uYmPwd3uQ3VUHxGR7NAa.ifWVAp1joHrHt533r0Zc {
  color: #FCFCFC;
}

.uYmPwd3uQ3VUHxGR7NAa.ifWVAp1joHrHt533r0Zc {
  background: #EFEFEF;
}
.dark-mode .uYmPwd3uQ3VUHxGR7NAa.ifWVAp1joHrHt533r0Zc {
  background: #272B30;
}

.uYmPwd3uQ3VUHxGR7NAa:not(:last-child) {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .uYmPwd3uQ3VUHxGR7NAa:not(:last-child) {
    margin-right: 0;
  }
}

.YSTSCTV9NdUCVTHh015b {
  margin-left: 8px;
}
@media only screen and (max-width: 1023px) {
  .YSTSCTV9NdUCVTHh015b {
    display: none;
  }
}

.rb1wUh3jA7r8Rf6XFfMk {
  display: none;
}

.fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q {
  display: flex;
}
.fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q .JXFXB7ZooGVwAttWWGSS {
  flex-shrink: 0;
  width: 384px;
}
@media only screen and (max-width: 1419px) {
  .fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q .JXFXB7ZooGVwAttWWGSS {
    width: 350px;
  }
}
@media only screen and (max-width: 1259px) {
  .fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q .JXFXB7ZooGVwAttWWGSS {
    width: 320px;
  }
}
@media only screen and (max-width: 1023px) {
  .fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q .JXFXB7ZooGVwAttWWGSS {
    display: none;
  }
}
.fKaeT9EQOjwy9twTdBxb.u108chOPolOIE7ZCSU6Q .rb1wUh3jA7r8Rf6XFfMk {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/pages/events/list/CustomerList.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ;ACWI;EDXJ;IAGQ,mBAAA;EACN;AACF;ACSI;EDdJ;IAKQ,eAAA;IACA,mBAAA;EAIN;AACF;AAJI;EACI,kBAAA;AAMR;ACHI;EDJA;IAGQ,YAAA;EAQV;AACF;ACLI;EDPA;IAKQ,WAAA;IACA,gBAAA;EAWV;AACF;ACdI;EDGA;IAEQ,aAAA;EAaV;AACF;;AAZA;EACI,kBAAA;AAeJ;ACpBI;EDIJ;IAGQ,gBAAA;EAiBN;AACF;;AAhBA;EACI,aAAA;AAmBJ;AC7BI;EDSJ;IAGQ,WAAA;EAqBN;AACF;;AApBA;EACI,iBAAA;EACA,kBAAA;EC8CA,eAAA;EACA,gBAAA;EACA,gBAAA;ED9CA,cCUC;EDTD,oBAAA;AAyBJ;AC5CI;EDcJ;IAOQ,OAAA;EA2BN;AACF;AA3BI;EAEI,cCOH;ADqBL;ACwHa;EDlJD,cCDP;AD8BL;;AA5BI;EACI,mBCDH;ADgCL;ACiHa;ED9ID,mBAAA;AAgCZ;;AA/BI;EACI,iBAAA;AAkCR;AClEI;ED+BA;IAGQ,eAAA;EAoCV;AACF;;AAnCA;EACI,gBAAA;AAsCJ;AC9EI;EDuCJ;IAGQ,aAAA;EAwCN;AACF;;AAvCA;EACI,aAAA;AA0CJ;;AAvCI;EACI,aAAA;AA0CR;AAzCQ;EACI,cAAA;EACA,YAAA;AA2CZ;ACxGI;ED2DI;IAIQ,YAAA;EA6Cd;AACF;ACvGI;EDqDI;IAMQ,YAAA;EAgDd;AACF;ACzGI;EDkDI;IAQQ,aAAA;EAmDd;AACF;AAnDQ;EACI,cAAA;AAqDZ","sourcesContent":["@import ../../../styles/helpers\n\n.head\n    margin-bottom: 44px\n    +t\n        margin-bottom: 32px\n    +m\n        flex-wrap: wrap\n        margin-bottom: 24px\n    .form\n        margin-right: auto\n        +t\n            width: 250px\n        +m\n            width: 100%\n            margin: 0 0 16px\n    &.hidden\n        +t\n            display: none\n\n.title\n    margin-right: 24px\n    +m\n        margin: 0 0 16px\n\n.nav\n    display: flex\n    +m\n        width: 100%\n\n.link\n    padding: 8px 16px\n    border-radius: 8px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    +m\n        flex: 1\n    &:hover,\n    &.active\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        +dark\n            background: $n6\n    &:not(:last-child)\n        margin-right: 8px\n        +m\n            margin-right: 0\n\n.filters\n    margin-left: 8px\n    +t\n        display: none\n\n.details\n    display: none\n\n.row\n    &.flex\n        display: flex\n        .table\n            flex-shrink: 0\n            width: 384px\n            +w\n                width: 350px\n            +d\n                width: 320px\n            +t\n                display: none\n        .details\n            display: block","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": `nzuXgaNlWlaEF1hh2NBO`,
	"form": `vX9M5hWWqM3YLueggWdM`,
	"hidden": `Qkwr8d5qz_GSOip5WRo4`,
	"title": `IRyGOm_CKwD_geczKAF5`,
	"nav": `EfBrtUtmpKTkb4q7_lzQ`,
	"link": `uYmPwd3uQ3VUHxGR7NAa`,
	"active": `ifWVAp1joHrHt533r0Zc`,
	"filters": `YSTSCTV9NdUCVTHh015b`,
	"details": `rb1wUh3jA7r8Rf6XFfMk`,
	"row": `fKaeT9EQOjwy9twTdBxb`,
	"flex": `u108chOPolOIE7ZCSU6Q`,
	"table": `JXFXB7ZooGVwAttWWGSS`
};
export default ___CSS_LOADER_EXPORT___;
